import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;

  padding-right: 8px;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  margin-right: 8px;
`;

export const AsteriskWrapper = styled.div`
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
`;
